import { useGetSMSManagement } from 'services/hooks/queries';
import { SMSTabs } from './components';

export const SMSManagementPage = () => {
    const { smsManagementData, isSMSManagementLoading, isSMSManagementError } = useGetSMSManagement();

    console.log(smsManagementData);

    return (
        <div className='p-xl flex flex-col gap-xl'>
            {/* Header */}
            <div>
                <h1 className='text-3xl font-bold'>SMS Management</h1>
                <p className='text-gray-900 mt-sm text-base'>
                    Manage your SMS templates, track conversations, and analyze performance.
                </p>
            </div>

            <SMSTabs />
        </div>
    );
};

export default SMSManagementPage;
